export default {
    title: process.env.VUE_APP_TITLE || 'Sign-In',
    logo: process.env.VUE_APP_LOGO || '/img/logo-square.png',
    logoFull: process.env.VUE_APP_LOGO_FULL || '/img/logo.png',
    recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY || '',
    appType: process.env.VUE_APP_TYPE || 'user',
    authApiUrl: process.env.VUE_APP_AUTH_API_URL || 'https://auth_api',
    privacyLink: process.env.VUE_APP_PRIVACY_LINK || false,
    termsLink: process.env.VUE_APP_TERMS_LINK || false,
    themes: {
        light: {
            primary: process.env.VUE_APP_THEMES_LIGHT_PRIMARY_COLOR || '#0B2E37',
            secondary: process.env.VUE_APP_THEMES_LIGHT_SECONDARY_COLOR || '#8F3042',
            accent: process.env.VUE_APP_THEMES_LIGHT_ACCENT_COLOR || '#18797A',
            error: process.env.VUE_APP_THEMES_LIGHT_ERROR_COLOR || '#C81E45',
            info: process.env.VUE_APP_THEMES_LIGHT_INFO_COLOR || '#18797A',
            success: process.env.VUE_APP_THEMES_LIGHT_SUCCESS_COLOR || '#15803D',
            warning: process.env.VUE_APP_THEMES_LIGHT_WARNING_COLOR || '#F0A10E'
        }
    },
    telDefaultCountry: process.env.VUE_APP_TEL_INPUT_DEFAULT_COUNTRY || 'IE',
    passwordResetRedirect: process.env.VUE_APP_PASSWORD_RESET_REDIRECT || undefined,
    twoFactorEnabled: (process.env.VUE_APP_TWO_FACTOR_ENABLED === 'true'),
    twoFactorAllowedMethods: process.env.VUE_APP_TWO_FACTOR_ALLOWED_METHODS_CSV ? process.env.VUE_APP_TWO_FACTOR_ALLOWED_METHODS_CSV.split(',') : ['sms', 'email'],
    recaptchaEnabled: (process.env.VUE_APP_RECAPTCHA_ENABLED && process.env.VUE_APP_RECAPTCHA_ENABLED === 'true'),
    defaultAppRedirectEnabled: (process.env.VUE_APP_DEFAULT_APP_REDIRECT_ENABLED === 'true'),
    defaultAppRedirectUrl: process.env.VUE_APP_DEFAULT_APP_REDIRECT_URL,
    bcp47LanguageTag: process.env.VUE_APP_BCP47_LANGUAGE_TAG || 'en-US',
    passwordResetEnabled: (process.env.VUE_APP_PASSWORD_RESET_ENABLED === 'true'),
    passwordCreateEnabled: (process.env.VUE_APP_PASSWORD_CREATE_ENABLED === 'true'),
    checkTosEnabled: (process.env.VUE_APP_CHECK_TOS_ENABLED === 'true'),
    tosTemplate: process.env.VUE_APP_TOS_TEMPLATE,
    background: process.env.VUE_APP_BACKGROUND,
    dateFormat: process.env.VUE_APP_DATE_FORMAT || 'YYYY-MM-DD',
    passwordMinLength: process.env.VUE_APP_PASSWORD_MIN_LENGTH || '4',
    googleApiClientId: process.env.VUE_APP_GOOGLE_API_CLIENT_ID,
    contactUsLink: process.env.VUE_APP_CONTACT_US_LINK || 'mailto:test@test.com'
};
